module.exports = __webpack_public_path__ + "static/media/S1N9-2.b7ede6c1.svg";